import { ApiClientErrorResponse } from '~/ApiClient';

import ItemsLimitError from './ItemsLimitError';

const ExportItemsLimitErrorCode = 'product-group-export-items-limit';

export default class ExportErrorResponse extends ApiClientErrorResponse {
	handleGroupRequiresAtLeastOneProduct(): boolean {
		return this.handle('product-group-requires-at-least-one-product');
	}

	handlepGroupExportItemsLimit(): boolean {
		return this.handle(ExportItemsLimitErrorCode);
	}

	findExportItemsLimitError(): ItemsLimitError | null {
		const error = this.errors.find((candidate) => candidate.code === ExportItemsLimitErrorCode);
		return error !== undefined ? new ItemsLimitError(error.meta.actual, error.meta.limit) : null;
	}
}
